export interface IClient {
  id: string;
  name: string;
  phone: string;
  email: string;
  companyTaxId: string;
  address: string;
  city: string;
  postalCode: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface IClientRes {
  data: IClient;
}

export interface IClientsRes {
  data: IClient[];
  count: number;
}

export interface IFormValues {
  name: string;
  companyTaxId: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  postalCode: string;
  
}


export enum ClientStatus {
  Active = "Active",
  Inactive = "Inactive",
  Delete = "Delete",
}